import createUmbracoMediaItemProps from '@/components/atoms/media/umbracoMediaElementPropsFactory'
import { DetailInfo, HeadingComponent } from './'
import { GetUmbracoBaseUrl } from '@/utils/urlHelpers'
import { Cultures } from '@/types/enums'
export default function headingComponentFactory(
  data: any,
  culture: Cultures,
  key: string | number,
) {
  const content = data?.content?.properties
  const mediaItem = content?.mediaItem?.items?.[0]?.content
  const mediaItemProps = createUmbracoMediaItemProps({
    mediaItemContent: mediaItem,
    umbracoBaseUrl: GetUmbracoBaseUrl(),
  })

  const detailInfo: DetailInfo = {
    publicationDate:
      content?.publicationData || data?.createDate || content?.createDate,
    hidePublicationDate: content?.hidePublicationDate,
    type: content?.type,
    location: content?.location,
    surface: content?.surface,
    status: content?.status,
  }

  return (
    <HeadingComponent
      key={`heading-${key}`}
      title={content?.title?.markup}
      smallHeader={content?.smallHeader}
      subtitle={content?.subtitle}
      button={content?.button?.[0]}
      mediaData={mediaItemProps}
      detailInfo={detailInfo}
      culture={culture}
    />
  )
}
